import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
export const ConditionalWrapper = ({ condition, wrapper, children, }) => {
    return condition ? (wrapper(children)) : (_jsx(React.Fragment, { children: children }));
};
//# sourceMappingURL=ConditionalWrapper.js.map